import { useTranslation } from "react-i18next";
import { spinnerProps } from "./Ispinner";
import "./Spinner.scss";

const Spinner = (props: spinnerProps) => {
    const { t } = useTranslation();
	return (
		<div className={"loader container " + (props?.mloSpinner ? " mlo" : "")}>

			<div
				id="spinner-1"
				className={
					"loader-section spinner " +
					(props?.isSmallSpinner ? "fixed" : "spinner-lg") +
					(props?.mloSpinner ? " fixed" : "")
				}
				tabIndex={-1}
				role="alert"
				aria-live="assertive"
			>
				<span
					role="presentation"
					className="loader-section-dot spinner-dot spinner-dot-1"
				></span>
				<span
					role="presentation"
					className="loader-section-dot spinner-dot spinner-dot-2"
				></span>
				<span
					role="presentation"
					className="loader-section-dot spinner-dot spinner-dot-3"
				></span>
				<span
					role="presentation"
					className="loader-section-dot spinner-dot spinner-dot-4"
				></span>
				<span
					role="presentation"
					className="loader-section-dot spinner-dot spinner-dot-5"
				></span>
				<span
					role="presentation"
					className="loader-section-dot spinner-dot spinner-dot-6"
				></span>
				<span
					role="presentation"
					className="loader-section-dot spinner-dot spinner-dot-7"
				></span>
				<span
					role="presentation"
					className="loader-section-dot spinner-dot spinner-dot-8"
				></span>
				<span
					role="presentation"
					className="loader-section-dot spinner-dot spinner-dot-9"
				></span>
				<span
					role="presentation"
					className="loader-section-dot spinner-dot spinner-dot-10"
				></span>
			</div>
			{props?.mloSpinner && (
				<span className="mlo-spinnertext label-lead">
					{t("MLO_OPTIMIZER.LOADER_MESSAGE.value")}
				</span>
			)}
		</div>
	);
};

export default Spinner;
